import {
    SET_SELECTED_PRODUCTS,
    SET_SHOPPING_CART,
    SET_RESULTS_SELECTION,
} from 'od-modules/secure_store/actions';

export default function productSelection(state = {}, action) {
    switch (action.type) {
        case SET_SELECTED_PRODUCTS:
            return Object.assign({}, state, {products: tryParseNewEntry(action.entry)});
        case SET_RESULTS_SELECTION:
            return Object.assign({}, state, {resultsSelected: true});
        case SET_SHOPPING_CART:
            return Object.assign({}, state, {
                flight: {
                    travellers: action.entry && action.entry.travellers,
                    buyer: action.entry && action.entry.buyerDTO,
                }});
        default:
            return state;
    }
}

const tryParseNewEntry = (entry) => {
    let newEntry;
    try {
        newEntry = JSON.parse(entry);
    } catch (e) {
        newEntry = Array.isArray(entry) ? [] : {};
    }
    return newEntry;
};
